import { api } from 'services';

type DownloadOutput = {
  base64: string;
  ext: string;
  filename: string;
};

export async function downloadReport(reportId: number) {
  const { data } = await api.get<DownloadOutput>(
    `scheduled-reports/download/${reportId}`
  );

  fetch(data.base64)
    .then((response) => {
      return response.blob();
    })
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = data.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      console.error('Error downloading report', error);
    });
}
